import React from 'react'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { QuickFilter, QuickFilterClear, QuickFilterControl, Toolbar } from '@mui/x-data-grid/components'
import { Cancel, Search } from '@mui/icons-material'

export const CustomDataGridToolbar = () => {
    return (
        <Toolbar sx={{ justifyContent: 'start', py: 3, pl: 2 }}>
            <QuickFilter expanded>
                <QuickFilterControl
                    render={({ ref, ...controlProps }, state) => (
                        <TextField
                            {...controlProps}
                            inputRef={ref}
                            aria-label='Sök'
                            placeholder='Sök...'
                            size='small'
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position='start'>
                                            <Search fontSize='small' />
                                        </InputAdornment>
                                    ),
                                    endAdornment: state.value ? (
                                        <InputAdornment position='end'>
                                            <QuickFilterClear
                                                edge='end'
                                                size='small'
                                                aria-label='Rensa'
                                                material={{ sx: { marginRight: -0.75 } }}
                                            >
                                                <Cancel fontSize='small' />
                                            </QuickFilterClear>
                                        </InputAdornment>
                                    ) : null,
                                    ...controlProps.slotProps?.input,
                                },
                                ...controlProps.slotProps,
                            }}
                        />
                    )}
                />{' '}
            </QuickFilter>
        </Toolbar>
    )
}
